module.exports = __webpack_public_path__ + "static/media/searchIcon.aacf14f6.svg";